import React from "react";
import "./Testimonials.css";

import girl1 from "../Assets/Frontend_Assets/w1.PNG";
import girl2 from "../Assets/Frontend_Assets/w2.PNG";
import boy1 from "../Assets/Frontend_Assets/m2.PNG";

const testimonialsData = [
  {
    name: "Emily Johnson",
    feedback:
      "Prime Cosmo hair oil transformed my hair within weeks. Smooth, shiny & healthy.",
    img: girl1,
  },
  {
    name: "Sophie Williams",
    feedback:
      "The goat milk soap feels premium and gentle. My skin feels refreshed daily.",
    img: girl2,
  },
  {
    name: "Oliver Smith",
    feedback:
      "Best beard oil I’ve used so far. Non-greasy and gives a natural shine.",
    img: boy1,
  },
];

const Testimonials = () => {
  return (
    <section className="lux-testimonials">

      {/* GLOWS */}
      <span className="lux-test-glow lux-test-glow-left"></span>
      <span className="lux-test-glow lux-test-glow-right"></span>

      <div className="lux-test-container">
        <span className="lux-eyebrow">REAL RESULTS</span>

        <h1 className="lux-test-title">
          What Our <span>Customers Say</span>
        </h1>

        <div className="lux-test-grid">
          {testimonialsData.map((item, index) => (
            <div key={index} className="lux-test-card">
              <div className="lux-test-avatar">
                <img src={item.img} alt={item.name} />
              </div>

              <p className="lux-test-feedback">“{item.feedback}”</p>

              <h4 className="lux-test-name">{item.name}</h4>

              <div className="lux-test-stars">
                ★★★★★
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
